import { SVGProps } from 'react';

const SvgCancel = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M20.132 3.868a1 1 0 0 1 0 1.415L13.414 12l6.718 6.718a1 1 0 1 1-1.415 1.414L12 13.414l-6.718 6.718a1 1 0 0 1-1.414-1.414L10.586 12 3.868 5.283a1 1 0 1 1 1.414-1.415L12 10.586l6.718-6.718a1 1 0 0 1 1.414 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgCancel;
